/** Historical tags may be an array, JSON list, plain text or indexed JSON object. */
export function tagValues(value) {
  if (value == null || value === "") return [];
  if (typeof value === "string") {
    try { return tagValues(JSON.parse(value)); }
    catch { return [value]; }
  }
  if (Array.isArray(value)) return value.flatMap(tagValues);
  if (typeof value === "object") return Object.values(value).flatMap(tagValues);
  return typeof value === "number" ? [String(value)] : [];
}
